import { buildSourceDocumentUrl } from "../../../utils/sourceNavigation";
import type { SearchResult } from "../SearchResultsCard";

export const buildDocumentSourceUrl = (
  result: SearchResult,
  query: string,
): string => {
  return buildSourceDocumentUrl(result, query);
};

// Check if message is asking for deep analysis
export const isDeepAnalysisRequest = (message: string): boolean => {
  // Deep analysis keywords - explicit requests for detailed/deep analysis
  const deepKeywords = [
    "詳細",
    "詳しく",
    "深く",
    "分析",
    "技術的",
    "deep",
    "detail",
    "technical",
    "analyze",
  ];
  const lowerMessage = message.toLowerCase();

  // Check both original message and lowercased version for better matching
  return deepKeywords.some(
    (keyword) =>
      message.includes(keyword) ||
      lowerMessage.includes(keyword.toLowerCase()),
  );
};
